import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Tabs,
  TimePicker,
  TreeSelect,
  Upload,
} from 'antd'
import {
  FormButtonGroup,
  InfoBlock,
} from './CompanyWorkScheduleCreatePageStyled'
import {
  CalendarOutlined,
  DeleteOutlined,
  EditOutlined,
  FieldTimeOutlined,
  FileTextOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import { toJS } from 'mobx'
import { Container } from '../../layouts/Container/Container'
import { EmptyText, WordBreak } from '../../components/Common/CellText'
import RichEditor from '../../components/RichEditor/RichEditor'
import { blue } from '../../color'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import utils from '../../utils'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_DEFAULT,
  DATE_FORMAT_LIST,
  HH_mm,
  HHhMM,
  ISO_DATE_FORMAT,
  TIME_FORMAT_LIST,
} from '../../constants'
import UploadFileItem from '../../components/Common/FileItemComponent/UploadFileItem'
import AccessControlAction from '../../components/AccessControlAction'
import RRule from './RRule'
import CompanyWorkScheduleConfirmSendNotificaitonModal from './CompanyWorkScheduleConfirmSendNotificationModal'
import validator from './../../validator'
import { systemName } from '../../config'
import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'
import { OfficeCalendarEventDetail } from '../CompanyWorkScheduleListPageV2/OfficeCalendarEventDetail'
import AppPageHeader from '../../components/AppPageHeader'

const { SHOW_CHILD } = TreeSelect
let submitValues

const CompanyWorkScheduleCreatePage = props => {
  const {
    fileStore,
    loadingAnimationStore,
    workScheduleStore,
    history,
    match,
    authenticationStore,
    departmentStore,
  } = props
  const { workScheduleDetail } = workScheduleStore
  const { currentUser } = authenticationStore
  const { departmentList } = departmentStore

  const {
    title,
    start_at,
    end_at,
    preparation,
    host,
    location,
    event_notice,
    attenders,
    assignees,
    created_at,
    last_edit_by,
    updated_at,
  } = workScheduleDetail

  const routeLocation = useLocation()
  const queryParams = useMemo(
    () =>
      queryString.parse(routeLocation.search, {
        arrayFormat: 'index',
      }),
    [routeLocation.search]
  )

  const { scheduleId } = match.params
  const [form] = Form.useForm()
  const EDITOR_REF = useRef()
  const [
    isCofirmSendNotificationModalVisible,
    setConfirmSendNotificationModalVisibility,
  ] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const confirmSendNotificationModal = Object.freeze({
    open: () => setConfirmSendNotificationModalVisibility(true),
    close: () => setConfirmSendNotificationModalVisibility(false),
  })

  const confirmUpdate = async ({ is_notification_required }) => {
    setIsLoading(true)
    try {
      await handleUpdateWorkSchedule({
        ...submitValues,
        is_notification_required,
      })
      confirmSendNotificationModal.close()
    } catch (error) {
      console.error('error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const filterCurrentUserDepartmentList = toJS(departmentList).filter(
    el => el.value !== currentUser?.username
  )

  const showPersonAndDate = (person, date) => {
    if (person) {
      return (
        <div>
          {`${utils.getNameInCapitalize(person)} - `}
          <span>{moment(date).format(DATE_FORMAT_DEFAULT)}</span>&nbsp;
          <span>{moment(date).format(HHhMM)}</span>
        </div>
      )
    }
    return <EmptyText>Chưa có thông tin</EmptyText>
  }

  const [fileList, setFileList] = useState([])
  const [editMode, setEditMode] = useState(true)
  const [checkEditSchedule, setCheckEditSchedule] = useState(false)

  const recipientNoticeList =
    assignees &&
    toJS(assignees).filter(el => el.permission === ASSIGNEE_TYPE.FOLLOWER)

  const handleChangeFile = useCallback(info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])

  const handleCreateWorkSchedule = async submitData => {
    const START_TIME = moment(submitData.start_time).format(HHhMM)
    const END_TIME = moment(submitData.end_time).format(HHhMM)
    const DATE_WORK = moment(submitData.start_at).format(DATE_FORMAT_DEFAULT)
    try {
      await workScheduleStore.createWorkSchedule(submitData)
      history.push('/company-work-schedule')
      message.success({
        content: submitData.end_time ? (
          <span>
            Tạo công việc ngày&nbsp;<b>{DATE_WORK}&nbsp;</b>
            thời gian từ&nbsp;<b>{START_TIME}&nbsp;</b>đến&nbsp;
            <b>{END_TIME}&nbsp;</b>thành công!
          </span>
        ) : (
          <span>
            Tạo công việc ngày&nbsp;<b>{DATE_WORK}&nbsp;</b>
            thời gian từ&nbsp;<b>{START_TIME}&nbsp;</b>thành công!
          </span>
        ),
      })
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Có lỗi xảy ra!')
    }
  }
  const handleUpdateWorkSchedule = async submitData => {
    const START_TIME = moment(submitData.start_time).format(HHhMM)
    const END_TIME = moment(submitData.end_time).format(HHhMM)
    const DATE_WORK = moment(submitData.start_at).format(DATE_FORMAT_DEFAULT)
    try {
      await workScheduleStore.updateWorkSchedule(scheduleId, submitData)

      if (queryParams?.date && queryParams?.company) {
        history.push(
          `/company-work-schedule?date=${queryParams?.date}&company=${queryParams?.company}&eventId=${scheduleId}`
        )
      } else {
        setCheckEditSchedule(false)
        setEditMode(false)
        handleGetWorkScheduleDetail()
      }

      message.success({
        content: submitData.end_time ? (
          <span>
            Cập nhật công việc ngày&nbsp;<b>{DATE_WORK}&nbsp;</b>thời gian
            từ&nbsp;
            <b>{START_TIME}&nbsp;</b>đến&nbsp;<b>{END_TIME}&nbsp;</b>thành công!
          </span>
        ) : (
          <span>
            Cập nhật công việc ngày&nbsp;<b>{DATE_WORK}&nbsp;</b>bắt đầu
            từ&nbsp;
            <b>{START_TIME}&nbsp;</b>thành công!
          </span>
        ),
      })
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Có lỗi xảy ra')
    }
  }

  const handleSubmitForm = useCallback(
    async values => {
      const START_AT = `${moment(values.start_date).format(
        ISO_DATE_FORMAT
      )} ${moment(values.start_time).format(HH_mm)}`
      const END_AT = values.end_time
        ? `${moment(values.start_date).format(ISO_DATE_FORMAT)} ${moment(
            values.end_time
          ).format(HH_mm)}`
        : null
      let arrRecipientNotice = []
      if (!checkEditSchedule) {
        arrRecipientNotice = values.recipient_notice
          ?.filter(el => !utils.isUpper(el))
          .map(code => ({
            assignee_code: code,
            assignee_type: ASSIGNEE_TYPE.USER,
            permission: ASSIGNEE_TYPE.FOLLOWER,
          }))
      } else {
        const recipient_notice = recipientNoticeList
          .filter(item => values.recipient_notice.includes(item.name_uppercase))
          .map(filteredItem => filteredItem.assignee_code)
        const result = [...values.recipient_notice, ...recipient_notice]
        arrRecipientNotice = result
          ?.filter(el => !utils.isUpper(el))
          .map(code => ({
            assignee_code: code,
            assignee_type: ASSIGNEE_TYPE.USER,
            permission: ASSIGNEE_TYPE.FOLLOWER,
          }))
      }

      const new_items = []
      const remove_items = []

      if (scheduleId) {
        const assignPersonUpdate = [...recipientNoticeList]
        arrRecipientNotice.forEach(user => {
          if (
            !assignPersonUpdate
              .map(el => el.assignee_code + el.permission)
              .includes(user.assignee_code + user.permission)
          ) {
            // push new_items
            new_items.push({
              assignee_code: user.assignee_code,
              assignee_type: user.assignee_type,
              permission: user.permission,
            })
          }
        })

        remove_items.push(
          ...assignPersonUpdate
            .filter(
              user =>
                !arrRecipientNotice.find(
                  el =>
                    el.assignee_code + el.permission ===
                    user.assignee_code + user.permission
                )
            )
            .map(user => ({
              assignee_code: user.assignee_code,
              assignee_type: user.assignee_type,
              permission: user.permission,
            }))
        )
      }

      let FILE_IDS = []
      if (scheduleId) {
        if (workScheduleDetail.file_ids.length) {
          FILE_IDS = workScheduleDetail.file_ids.map(file => file.file_id)
        }
      }

      submitValues = {
        attenders: values.attenders,
        end_time: values.end_time,
        host: values.host.replace(/\s+/g, ' ').trim(),
        location: values.location.replace(/\s+/g, ' ').trim(),
        preparation: values.preparation,
        start_date: values.start_date,
        start_time: values.start_time,
        title: '',
        start_at: moment(START_AT).toISOString(),
        end_at: END_AT ? moment(END_AT).toISOString() : null,
        file_ids: FILE_IDS,
        assignees: arrRecipientNotice,
        rrule: RRule.extractFromFormValues(values),
      }

      if (scheduleId) {
        submitValues = {
          ...submitValues,
          assignees: arrRecipientNotice,
          assign_person_update: {
            new_items: new_items.filter(
              el => el.assignee_code !== currentUser?.username
            ),
            remove_items: remove_items.filter(
              el => el.assignee_code !== currentUser?.username
            ),
          },
        }
      }

      submitValues.event_notice = EDITOR_REF?.current?.editor.getData()

      const uploadFileList = fileList.map(file => file.originFileObj)
      const batchUploadArr = []
      uploadFileList.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        batchUploadArr.push(fileStore.uploadFile(formData))
      })
      try {
        loadingAnimationStore.showSpinner(true)
        const response = await Promise.all(batchUploadArr)
        if (scheduleId) {
          submitValues.file_ids = [
            ...submitValues.file_ids,
            ...response.map(response => response.data.file_id),
          ]
          if (submitValues.assignees?.length === 0) {
            await handleUpdateWorkSchedule({
              ...submitValues,
              is_notification_required: true,
            })
          } else {
            confirmSendNotificationModal.open()
          }
          return
        }
        submitValues.file_ids = response.map(response => response.data.file_id)
        await handleCreateWorkSchedule(submitValues)
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    },
    [scheduleId, workScheduleDetail.file_ids, fileList, checkEditSchedule]
  )

  const handleRemoveAttachment = useCallback(
    fileId => {
      const newScheduleDetail = {
        ...workScheduleDetail,
        file_ids: toJS(workScheduleDetail.file_ids).filter(
          item => item.file_id !== fileId
        ),
      }
      workScheduleStore.updateWorkScheduleDetail(newScheduleDetail)
    },
    [workScheduleDetail]
  )

  const handleDeleteEvent = async () => {
    Modal.confirm({
      title: 'Xóa sự kiện',
      content: 'Bạn có chắc chắn muốn xóa sự kiện này?',
      okText: 'Đồng ý',
      cancelText: 'Hủy',
      onOk: async () => {
        try {
          loadingAnimationStore.showSpinner(true)
          await workScheduleStore.delete(scheduleId)
          message.success('Xóa sự kiện thành công!')
          history.push('/company-work-schedule')
        } catch (err) {
          console.log(err)
          message.error(err.vi || 'Đã có lỗi xảy ra!')
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      },
      okButtonProps: {
        danger: true,
        loading: loadingAnimationStore.isVisible,
      },
      cancelButtonProps: {
        disabled: loadingAnimationStore.isVisible,
      },
    })
  }

  const renderFormContent = () => (
    <Form
      form={form}
      scrollToFirstError={true}
      layout={'vertical'}
      name={'add-agenda-form'}
      onFinish={handleSubmitForm}
      initialValues={{
        start_date: moment(),
      }}>
      {/*<Form.Item*/}
      {/*  name={'title'}*/}
      {/*  label={'Tiêu đề'}*/}
      {/*  rules={[*/}
      {/*    { required: true, message: 'Vui lòng nhập tiêu đề sự kiện!' },*/}
      {/*    { max: 500, message: 'Tiêu đề không được quá 500 ký tự' },*/}
      {/*  ]}>*/}
      {/*<Input placeholder={'Nhập tiêu đề sự kiện'} />*/}
      {/*</Form.Item>*/}

      <div
        style={{
          minHeight: '100dvh',
        }}>
        <div
          style={{
            display: 'flex',
            gap: 24,
          }}>
          <div style={{ flex: 1, minWidth: 0, height: 'fit-content' }}>
            <div className="custom-create-page-content-wrapper">
              <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>
                Thông tin chung
              </h3>
              <Row gutter={20} style={{ margin: 0 }}>
                <Col span={8}>
                  <Form.Item
                    name={'start_date'}
                    label={'Ngày thực hiện'}
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng chọn ngày bắt đầu sự kiện!',
                      },
                    ]}>
                    <DatePicker
                      format={DATE_FORMAT_LIST}
                      style={{ width: '100%' }}
                      placeholder={'Chọn ngày thực hiện'}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name={'start_time'}
                    label={'Thời gian bắt đầu'}
                    rules={[
                      {
                        required: true,
                        message:
                          'Vui lòng nhập thời gian bắt đầu diễn ra sự kiện!',
                      },
                    ]}>
                    <TimePicker
                      format={TIME_FORMAT_LIST}
                      minuteStep={5}
                      style={{ width: '100%' }}
                      placeholder={'Bắt đầu'}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name={'end_time'} label={'Thời gian kết thúc'}>
                    <TimePicker
                      format={TIME_FORMAT_LIST}
                      minuteStep={5}
                      style={{ width: '100%' }}
                      placeholder={'Kết thúc'}
                    />
                  </Form.Item>
                </Col>

                {!scheduleId ? (
                  <Col span={24}>
                    <RecurrenceOption />
                  </Col>
                ) : null}

                <Col span={12}>
                  <Form.Item
                    label={'Địa điểm'}
                    name={'location'}
                    rules={[
                      { required: true, message: 'Vui lòng nhập địa điểm!' },
                      {
                        max: 2000,
                        message: 'Địa điểm không được quá 2000 ký tự',
                      },
                      { validator: validator.validateInputString },
                    ]}>
                    <Input placeholder={'Địa điểm'} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label={'Chủ trì'}
                    name={'host'}
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng nhập tên chủ trì sự kiện!',
                      },
                      {
                        max: 2000,
                        message: 'Chủ trì không được quá 2000 ký tự',
                      },
                      { validator: validator.validateInputString },
                    ]}>
                    <Input placeholder={'Chủ trì'} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <Tabs
              defaultActiveKey="1"
              destroyInactiveTabPane={false}
              style={{
                marginTop: 20,
              }}>
              <Tabs.TabPane tab="Nội dung" key="1" forceRender>
                <Form.Item label={'Nội dung sự kiện'} name={'event_notice'}>
                  <RichEditor
                    EDITOR_REF={EDITOR_REF}
                    placeholder={'Nhập nội dung sự kiện'}
                    editorContent={event_notice}
                  />
                </Form.Item>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Nội dung chuẩn bị" key="2" forceRender>
                <Form.Item
                  name={'preparation'}
                  label={'Chuẩn bị'}
                  rules={[
                    {
                      max: 2000,
                      message: 'Chuẩn bị không được quá 2000 ký tự',
                    },
                  ]}>
                  <Input placeholder={'Chuẩn bị'} />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Tài liệu đính kèm" key="3" forceRender>
                <Form.Item name={'file_ids'} label={'Tài liệu đính kèm'}>
                  <Upload
                    multiple={true}
                    valuePropName={'fileList'}
                    fileList={fileList}
                    onChange={handleChangeFile}
                    beforeUpload={() => false}
                    iconRender={() => <FileTextOutlined />}>
                    <Button icon={<UploadOutlined />}>
                      Chọn tài liệu đính kèm
                    </Button>
                  </Upload>
                </Form.Item>
                {workScheduleDetail.file_ids &&
                  workScheduleDetail.file_ids.length !== 0 && (
                    <Form.Item label={'Cập nhật tài liệu đính kèm'}>
                      {workScheduleDetail.file_ids.map(file => (
                        <UploadFileItem
                          key={file.file_id}
                          file_id={file.file_id}
                          file_name={file.file_title}
                          file_type={utils.getExtensionFile(file.file_title)}
                          isDownloadFile={true}
                          handleRemoveFileFromUploadList={() =>
                            handleRemoveAttachment(file.file_id)
                          }
                        />
                      ))}
                    </Form.Item>
                  )}
              </Tabs.TabPane>
            </Tabs>
          </div>

          <div
            className="custom-create-page-content-wrapper"
            style={{ width: 372, flexShrink: 0, height: 'fit-content' }}>
            <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>
              Thông tin bổ sung
            </h3>
            <Form.Item label="Thành viên tham gia" name={'attenders'}>
              <Input placeholder={'Thành viên tham gia'} />
            </Form.Item>
            <Form.Item label="Thông báo" name={'recipient_notice'}>
              <TreeSelect
                treeDataSimpleMode
                treeData={filterCurrentUserDepartmentList}
                style={{ width: '100%' }}
                showArrow
                allowClear
                showSearch
                filterTreeNode
                treeNodeFilterProp={'name'}
                treeCheckable={true}
                showCheckedStrategy={SHOW_CHILD}
                placeholder={'Chọn người nhận thông báo'}
              />
            </Form.Item>
          </div>
        </div>
      </div>

      <div className="custom-create-page-footer-sticky">
        <Button
          className="custom-ant-button w-160"
          onClick={() => {
            history.push('/company-work-schedule')
          }}>
          Hủy
        </Button>
        <Button
          className="custom-ant-button w-160"
          type={'primary'}
          htmlType={'submit'}>
          {scheduleId ? 'Cập nhật sự kiện' : 'Tạo mới sự kiện'}
        </Button>
      </div>
    </Form>
  )

  const renderViewContent = () => (
    <>
      {Boolean(workScheduleDetail) ? (
        <OfficeCalendarEventDetail
          onDeleteEvent={() => handleDeleteEvent()}
          onEditEvent={() => {
            setEditMode(true)
            setCheckEditSchedule(true)
          }}
          workScheduleDetail={workScheduleDetail}
        />
      ) : null}
    </>
  )

  useEffect(() => {
    ;(async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        await departmentStore.getDepartmentWithUsers(
          authenticationStore.currentCompanyCode()
        )
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [])

  const handleGetWorkScheduleDetail = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      setEditMode(false)
      await workScheduleStore.getWorkScheduleDetail(scheduleId)
    } catch (err) {
      history.push('/company-work-schedule')
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    if (scheduleId) {
      handleGetWorkScheduleDetail()
    }
    return () => {
      workScheduleStore.clearWorkScheduleDetail()
    }
  }, [scheduleId])

  useEffect(() => {
    scheduleId &&
      form.setFieldsValue({
        title: title,
        start_date: moment(start_at),
        start_time: moment(start_at),
        end_time: end_at && moment(end_at),
        host: host,
        location: location,
        event_notice: event_notice,
        attenders: attenders,
        preparation: preparation,
        recipient_notice: recipientNoticeList?.map(user => user.assignee_code),
      })
  }, [editMode, workScheduleDetail])

  useEffect(() => {
    if (queryParams?.mode === 'edit_form') {
      setEditMode(true)
      setCheckEditSchedule(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams?.mode])

  return (
    <DashboardLayout title={'Link People - Link the World'}>
      <CompanyWorkScheduleConfirmSendNotificaitonModal // Tạm thời không sử dụng modal nay
        visible={isCofirmSendNotificationModalVisible}
        onCancel={confirmSendNotificationModal.close}
        onConfirm={confirmUpdate}
        isLoading={isLoading}
      />
      <Helmet>
        <title>
          {scheduleId
            ? checkEditSchedule
              ? 'Chỉnh sửa sự kiện'
              : 'Chi tiết sự kiện'
            : 'Tạo mới sự kiện'}{' '}
          | {systemName} Portal
        </title>
      </Helmet>

      <AppPageHeader
        title={
          scheduleId
            ? checkEditSchedule
              ? 'Chỉnh sửa sự kiện'
              : 'Chi tiết sự kiện'
            : 'Tạo mới sự kiện'
        }
      />

      <ContentBlockWrapper>
        {editMode ? renderFormContent() : renderViewContent()}
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}
const RecurrenceOption = () => {
  const [isRecurrence, setRecurrenceStatus] = useState(false)
  const [frequenceType, setFrequenceType] = useState(RRule.FrequenceType.WEEKLY)
  const occurenceCountMax = {
    [RRule.FrequenceType.WEEKLY]: 4,
    [RRule.FrequenceType.MONTHLY]: 3,
  }
  const recurrenceText = {
    [RRule.FrequenceType.WEEKLY]: 'tuần xuất hiện',
    [RRule.FrequenceType.MONTHLY]: 'tháng xuất hiện',
  }

  const onToggleRecurrence = value => {
    setRecurrenceStatus(!!value)
  }

  const onChangeFrequenceType = value => {
    setFrequenceType(RRule.FrequenceType[value])
  }

  const frequenceTypeOptions = [
    {
      label: 'tuần',
      value: RRule.FrequenceType.WEEKLY,
    },
    {
      label: 'tháng',
      value: RRule.FrequenceType.MONTHLY,
    },
  ]

  const FrequenceTypeSelect = () => (
    <Form.Item
      name={'repeat_type'}
      style={{ margin: 0 }}
      initialValue={RRule.FrequenceType.WEEKLY}>
      <Select
        value={frequenceType}
        onChange={onChangeFrequenceType}
        style={{ width: 80 }}
        options={frequenceTypeOptions}
      />
    </Form.Item>
  )

  const DayOfWeekCheckboxGroup = () => (
    <Row style={{ margin: 0 }}>
      <Form.Item
        name={'day_of_weeks'}
        label={'Lặp lại vào'}
        rules={[
          { required: true, message: 'Bạn chưa chọn ngày trong tuần nào' },
        ]}>
        <Checkbox.Group>
          <Space size={'middle'}>
            <Checkbox value={RRule.DayOfWeek.MONDAY}>T2</Checkbox>
            <Checkbox value={RRule.DayOfWeek.TUESDAY}>T3</Checkbox>
            <Checkbox value={RRule.DayOfWeek.WEDNESDAY}>T4</Checkbox>
            <Checkbox value={RRule.DayOfWeek.THURSDAY}>T5</Checkbox>
            <Checkbox value={RRule.DayOfWeek.FRIDAY}>T6</Checkbox>
            <Checkbox value={RRule.DayOfWeek.SATURDAY}>T7</Checkbox>
            <Checkbox value={RRule.DayOfWeek.SUNDAY}>CN</Checkbox>
          </Space>
        </Checkbox.Group>
      </Form.Item>
    </Row>
  )

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          justifyContent: 'space-between',
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
          }}>
          <Form.Item name={'is_repeat'} style={{ margin: 0 }}>
            <Select
              defaultValue={0}
              onChange={onToggleRecurrence}
              style={{ width: 120 }}
              value={Number(isRecurrence)}
              options={[
                {
                  label: 'Không lặp lại',
                  value: 0,
                },
                {
                  label: 'Lặp lại',
                  value: 1,
                },
              ]}
            />
          </Form.Item>

          {isRecurrence ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ marginBottom: 8 }}>mỗi</div>

                <Form.Item
                  name={'repeat_interval'}
                  style={{ margin: 0 }}
                  initialValue={1}>
                  <InputNumber min={1} max={31} style={{ width: 70 }} />
                </Form.Item>
              </div>
              <FrequenceTypeSelect />
            </>
          ) : null}
        </div>

        {isRecurrence ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ marginBottom: 8 }}>Và kết thúc sau</span>
            <Form.Item
              style={{ margin: 0 }}
              name={'repeat_count'}
              rules={[
                {
                  required: true,
                  message: 'Số lần lặp lại không được để trống',
                },
              ]}
              initialValue={1}>
              <InputNumber
                style={{ width: 170 }}
                min={1}
                max={occurenceCountMax[frequenceType]}
                addonAfter={
                  <span style={{ textAlign: 'center', color: 'gray' }}>
                    {recurrenceText[frequenceType]}
                  </span>
                }
              />
            </Form.Item>
          </div>
        ) : null}
      </div>

      {isRecurrence && frequenceType === RRule.FrequenceType.WEEKLY ? (
        <DayOfWeekCheckboxGroup />
      ) : null}
    </>
  )
}

CompanyWorkScheduleCreatePage.propTypes = {}

export default memo(
  inject(
    'commonStore',
    'loadingAnimationStore',
    'departmentStore',
    'workScheduleStore',
    'fileStore',
    'authenticationStore'
  )(observer(CompanyWorkScheduleCreatePage))
)
